import { ReactComponent as Add } from '../../../../images/icons/add.svg';
interface Props{
    onClick: () => void;
}

const BtnAdd = ({ onClick }: Props) => {
    return (
        <button data-testid="btn-add" className="flex justify-center items-center w-[70px] h-[70px] md:w-[157px] md:h-[157px] text-[#252429] fill-current hover:fill-white bg-[#E2E1E1] border-solid border-white border-[5px] rounded-full mb-[7px] hover:bg-[#198754] hover:drop-shadow-[8px_8px_30px_rgba(0,0,0,0.25)] transition-all ease-in-out duration-200"
            type="button"
            onClick={onClick}>
            <Add className='w-[30px] h-[30px] md:w-[45px] md:h-[45px]'/>
        </button>
    )
}

export default BtnAdd;